var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.PanelManagerMobile = new Class({
    Extends: OCS.WxBriefing.Classes.PanelManager,
    mobile_panel_chooser: null,
    panel: null,
    init_panels: function () {
        if (!this.panel) {
            this.panel = this.create_panel(1, {});
        }
    },
    init_panel: function (panel_element) {
        // No panel dragging functionality available in mobile.
    },
    build_panel_config: function (panel_config, options) {
        // Since we are building out a new panel config start at panel 1
        if (panel_config.num_of_panels) {
            if (!this.mobile_panel_chooser) {
                this.mobile_panel_chooser = new OCS.WxBriefing.Classes.PanelChooserMobile(document.id("mobile_panel_chooser"), {max_panels: panel_config.num_of_panels});
                this.mobile_panel_chooser.addEvent(this.mobile_panel_chooser.options.current_panel_update_event, this.on_current_panel_update_event.bind(this));
            }
            this.mobile_panel_chooser.set_max_panels(panel_config.num_of_panels);
            
        }
    },
    load_panel_config: function (state, old_state) {
        var panel_config = this.get_panel_config(state.panel_config);
        if (state !== null) {
            // Set the panel container to the new panel config class
            this.build_panel_config(panel_config);
        }
    },

    on_current_panel_update_event: function (current_panel) {
        this.panel.set_panel_id(this.options.panel_id_name_prefix + current_panel);
    },
    create_panel_obj: function (container, ops) {
        return new OCS.WxBriefing.Classes.PanelObjMobile(container, ops);
    },

    destroy: function () {
        this.mobile_panel_chooser.destroy();
        this.mobile_panel_chooser = null;
        this.parent();
    }
});

